import React, { useEffect } from "react";
import JobItem from "./JobItem";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../ui/Loading";
import { fetchJobs } from "../../features/jobs/jobsSlice";

const JobList = () => {
  const { jobs, isLoading, isError, error } =
    useSelector((state) => state.jobs) || {};
  const { search, sortOption, type } =
    useSelector((state) => state.filters) || {};
  const dispatch = useDispatch();

  const filterByType = (job) => {
    switch (type) {
      case "Remote":
        return job?.type === type;
      case "Full Time":
        return job?.type === type;
      case "Internship":
        return job?.type === type;
      default:
        return job;
    }
  };
  const filterBySearch = (job) => {
    const titleToMatch = job?.title.toLowerCase();
    const filterSearchText = search.toLowerCase();
    return titleToMatch.includes(filterSearchText);
  };

  const filterBySortOption = (jobOne, jobTWo) => {
    switch (sortOption) {
      case "Salary_Ascending_Order":
        return Number(jobOne?.salary) - Number(jobTWo?.salary);
      case "Salary_Descending_Order":
        return Number(jobTWo?.salary) - Number(jobOne?.salary);
      default:
        return true;
    }
  };

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  // decide whats to render...
  let content;

  if (isLoading) content = <Loading text="Loading" style="loading" />;
  if (!isLoading && isError) content = <Loading text={error} style="loading" />;
  if (!isLoading && !isError && jobs.length > 0)
    content = jobs
      .filter(filterByType)
      .filter(filterBySearch)
      .sort(filterBySortOption)
      .map((job) => <JobItem key={job?.id} job={job} />);
  if (!isLoading && !isError && jobs.length === 0)
    content = <Loading text="No jobs available" style="loading" />;

  // render items
  return <div className="jobs-list">{content}</div>;
};

export default JobList;
